import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { ellipsis } from 'polished'
import { layout } from '@measures/responsive'
import Blink from '@components/Blink'
import { Credit as CreditType } from '@cook-types/cook'

interface CreditProps extends CreditType {
  isInMultiGallery?: boolean
}

type CreditWrapperProps = Pick<CreditProps, 'isInMultiGallery'>

const Wrapper = styled.div<CreditWrapperProps>`
  ${({
    theme: {
      colors: {
        white,
        grey: { grey_100 },
      },
    },
    isInMultiGallery,
  }) => css`
    position: absolute;
    right: 2px;
    top: 0;
    color: ${white};
    z-index: 1;
    transform: rotate(-180deg);
    font-size: 12px;
    line-height: 20px;
    text-transform: uppercase;
    writing-mode: tb-rl;
    user-select: none;
    padding: 12px 2px;
    box-sizing: border-box;
    max-height: ${isInMultiGallery ? 'calc(50% - 48px/2)' : '100%'};
    ${ellipsis(isInMultiGallery ? 'calc(50% - 48px/2)' : '100%')}
    text-shadow: 0 0 5px ${grey_100},
        0 0 8px ${grey_100}, 0 0 10px ${grey_100};

    @media ${layout.tablet.minWidth} {
      text-align: right;
    }
  `}
`

const StyledBlink = styled(Blink)`
  ${({
    theme: {
      colors: { white },
    },
  }) => css`
    position: relative;
    color: ${white};
  `}
`

const Credit: FunctionComponent<CreditProps> = ({
  text,
  link,
  isInMultiGallery,
}) => {
  if (!text) return null

  return (
    <Wrapper isInMultiGallery={isInMultiGallery}>
      {link?.href ? <StyledBlink {...link}>{text}</StyledBlink> : text}
    </Wrapper>
  )
}

export default Credit
